import { render, staticRenderFns } from "./HiloTableV2.vue?vue&type=template&id=67fe8d88&scoped=true"
import script from "./HiloTableV2.vue?vue&type=script&lang=js"
export * from "./HiloTableV2.vue?vue&type=script&lang=js"
import style0 from "./HiloTableV2.vue?vue&type=style&index=0&id=67fe8d88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fe8d88",
  null
  
)

export default component.exports